module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAABHNCSVQICAgIfAhkiAAAASZJREFUOI3dlM9KAlEYxc+5TKBTJD2BtJc7QtDKvQ/goh5AsI3UE4huXc0wK8EHqEUvkrTIFxCfIIyZKUnmtLAixakBhcCzuvDd8/vO/QvsWPwaWD/SNqDxzREBwGybaF1OVqe8Wl/ZzhP+D7AaxN1qEHd31tX6kfLegj3Zwz0Hen7cs8G88pfRBvOK58e9X4HWTxqCOsBi5AXxVRZsWVuMBHWsnzR+1lbe7dlA7vtbEkBqAgDJex67zXQWPwOAKR2e6CUZSlpCyOFBwb1+bDHZCPxOECYXSNOBhBLJqaTyZ4OppDKJGYxpPbXdu3Vv5s9iw9dTpumtpPMVA/kgYy7H7eJkky/zlMft4sQpuDXS9EEKpEjTdwpuLQuWW14Y1b0wqueZ+wGzGGv52Ds4AAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/ic_download.png
// module id = 791
// module chunks = 170